<template>
	<div class="content-div">
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<!-- <searchForm ref="MyTerm" @show="show" ></searchForm> -->
		<!-- <div class="demo-split">
			<Split v-model="split1">
				<div slot="left" class="demo-split-pane">
					<LeftForm ref="MyTermFile" @show="show" @handleSubmitFile="handleSubmitFile" @delFile="delFile">
					</LeftForm>
					<Table ref="currentRowTable" :columns="columnsFile" :data="Filedata" :height="tableHeight" size="small">
						<MyPage slot="footer" ref="sonPageFile" :param="SelectParamFile" :url="getUpgradeFilesUrl"
							@listData='getFileList'></MyPage>
					</Table>
				</div>
				<div slot="right" class="demo-split-pane">
					<RightForm ref="MyTermList" @show="show" @handleSubmitList="handleSubmitList" @Upgrade='Upgrade'>
					</RightForm>
					<Table @on-selection-change="selectChangeList" :columns="columnsList" :data="Listdata" :height="tableHeight"
						size="small">
						<MyPage slot="footer" ref="sonPageList" :param="SelectParamList" :url="getEquipmentInfoUrl" @listData='getDeviceList'>
						</MyPage>
					</Table>
				</div>
			</Split>
		</div> -->
		<Row :gutter="10" style="flex-wrap: nowrap; width: 100%;">
			<!-- <Col span="12">
			<LeftForm ref="MyTermFile" @show="show" @handleSubmitFile="handleSubmitFile" @delFile="delFile">
			</LeftForm>
			</Col> -->
			<Col :span="24">
			<RightForm ref="MyTermList" @show="show" @handleSubmitList="handleSubmitList" @Upgrade='Upgrade'>
			</RightForm>
			</Col>
		</Row>
		<Row :gutter="10" style="flex-wrap: nowrap; width: 100%">
			<Col flex="430px">
			<Table ref="currentRowTable" border :columns="columnsFile" :data="Filedata" :height="tableHeight" size="small">
				<MyPage slot="footer" ref="sonPageFile" :param="SelectParamFile" :url="getUpgradeFilesUrl"
					@listData='getFileList'></MyPage>
			</Table>
			</Col>
			<Col flex="auto" style="overflow-x: auto;">
			<Table @on-selection-change="selectChangeList" border :columns="columnsList" :data="Listdata" :height="tableHeight"
				size="small">
				<MyPage slot="footer" ref="sonPageList" :param="SelectParamList" :url="getEquipmentInfoUrl"
					@listData='getDeviceList'>
				</MyPage>
			</Table>
			</Col>
		</Row>
	</div>
</template>

<script>
	import {
		mapState,
	} from 'vuex'
	import webapi from '../../../webapi';
	import searchForm from './Template/RemoteUpgradeForm.vue';
	//import LeftForm from './Template/RemoteUpgradeFormLeft.vue';
	import RightForm from './Template/RemoteUpgradeFormRight.vue';
	//import FileModal from './Template/UpgradeFileModal.vue';
	//import ListModal from './Template/UpgradeListModal.vue';
	// import DistributeModal from './Template/DistributeModal.vue';
	export default {
		components: {
			//searchForm,
			//LeftForm,
			RightForm
			// DistributeModal
		},
		data() {
			return {
				getUpgradeFilesUrl: webapi.base_api_url + '/System/GetUpgradeFiles',
				getEquipmentInfoUrl: webapi.base_api_url + '/System/GetEquipmentInfo',
				//面板分割线
				split1: 0.4,
				//查询组件的参数
				SelectParam: {},
				SelectParamFile: {},
				SelectParamList: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: ['系统管理', '>>', '控件管理'],
				Flag: 'File',
				//table标题数据
				columnsFile: [{
						// title: '选择',
						key: 'id',
						width: 35,
						align: 'center',
						render: (h, params) => {
							let id = params.row.Id;
							let flag = false;
							if (this.selectedFileId === id) {
								flag = true
							}
							let self = this
							return h('div', [
								h('Radio', {
									props: {
										value: this.selectedFileId === id,
									},
									on: {
										'on-change': () => {
											self.selectedFileId = id;
											self.selectedFileItem = params.row;
										}
									}
								})
							])
						}
					},
					// {
					// 	type: 'index',
					// 	width: 60,
					// 	align: 'center'
					// },
					{
						title: '文件名',
						key: 'FileName',
						minWidth: 200,
					},
					// {
					// 	title: '文件大小',
					// 	key: 'FileSize',
					// },
					{
						title: '版本',
						key: 'FileVersion',
						minWidth: 100,
					},
					{
						title: '备注',
						key: 'Remark',
						minWidth: 130,
					},
					// {
					// 	title: '校验',
					// 	key: 'FileVerify',
					// },
					// {
					// 	title: '上传时间',
					// 	key: 'UploadTime',
					// 	minWidth: 80,
					// },
				],
				columnsList: [{
						type: 'selection',
						width: 35,
						align: 'center'
					},
					{
						title: 'ID',
						key: 'ConnectorId',
						minWidth: 50,
					},
					// {
					// 	title: '设备编号',
					// 	key: 'ConnectorNo',
					// 	minWidth: 120,
					// },
					{
						title: '设备序列号',
						key: 'EquipmentSerialNo',
						minWidth: 100,
					},
					{
						title: '设备编码',
						key: 'EquipmentNo',
						minWidth: 110,
					},
					// {
					// 	title: '设备类型',
					// 	key: 'EquipmentType',
					// 	minWidth: 120,
					// 	render: (h, params) => {
					// 		return h('div', params.row.EquipmentTypeDesc)
					// 	}
					// },
					{
						title: '设备型号',
						key: 'EquipmentModel',
						minWidth: 120,
					},
					{
						title: '状态',
						key: 'EquipmentStatus',
						minWidth: 50,
						render: (h, params) => {
							return h('div', params.row.EquipmentStatusDesc)
						}
					}, {
						title: '程序版本',
						key: 'SoftVersion',
						minWidth: 65,
					}, {
						title: '场站名',
						key: 'StationName',
						minWidth: 90,
					}, {
						title: '操作状态',
						key: 'Code',
						minWidth: 65,
					}, {
						title: '操作消息',
						key: 'Msg',
						minWidth: 110,
					},
				],
				Filedata: [],
				Listdata: [],
				selectedFileId: '',
				selectedListId: [],
				selectedFileItem: {},
				selectedEquipList: [],
			}
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			_this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			//this.SelectParam = this.$refs.MyTerm.formInline
			this.SelectParamList = this.$refs.MyTermList.formInline
			this.SelectParamFile = this.$refs.MyTermList.formInline
			this.$nextTick(() => {
				// this.handleSubmitFile();
				this.handleSubmitList();
			})
		},
		computed: {
			//直接选属性
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine',
			})
		},
		methods: {
			selectChangeList: function(EquipmentList) {
				this.selectedListId = EquipmentList.map(function(Equipment) {
					console.log(Equipment.EquipmentNo);
					return {
						ConnectorId: Equipment.ConnectorId,
						ConnectorNo: Equipment.ConnectorNo,
						EquipmentId: Equipment.EquipmentId,
						EquipmentNo: Equipment.EquipmentNo
					};
				});
				this.selectedEquipList = EquipmentList;
			},
			selectChangeFile: function(currentRow, oldCurrentRow) {
				this.selectedFileId === currentRow.Id
			},
			trimSpecific: function(str, char) {
			    // 使用正则表达式匹配字符串开头和结尾的指定字符
			    // \b 表示单词边界，这里用来确保只匹配开头和结尾的指定字符
			    // 注意：如果你的目标是移除所有出现的指定字符，而不是仅在开头和结尾，请使用下面的方法
			    return str.replace(new RegExp(`^${char}+|${char}+$`, 'g'), '');
			},
			Upgrade: function() {
				const _this = this
				if (_this.selectedFileId == '') {
					_this.$Message.error("请点击文件列表选择升级文件")
					return;
				}
				if (_this.selectedListId.length == 0) {
					_this.$Message.error("请点击设备列表选择升级设备")
					return;
				}
				this.$Modal.confirm({
					title: '是否升级设备？',
					okText: '取消',
					cancelText: '确定',
					onCancel: () => {
						const verFile = _this.trimSpecific(_this.trimSpecific(_this.selectedFileItem.FileVersion, 'v'), 'V').split('.');
						console.log("verFile: ", verFile);
						for (let i = 0; i < _this.selectedEquipList.length; i++) {
							const verSoft = _this.trimSpecific(_this.trimSpecific(_this.selectedEquipList[i].SoftVersion, 'v'), 'V').split('.');
							if (verSoft.length < 3 || verFile.length < 3) {
								this.$Message.error({
									content: '版本号不正确',
									druation: 5,
									background: true,
								});
								return;
							}
							if (verSoft[0] != verFile[0] || verSoft[1] != verFile[1]) {
								this.$Message.error({
									content: '版本号不兼容',
									druation: 5,
									background: true,
								});
								return;
							}
						}
						
						let MyListdata1 = []
						_this.Listdata.map(function(resItem) {
							_this.selectedListId.map(function(item) {
								if (item.ConnectorId == resItem.ConnectorId) {
									resItem.Code = -2
									resItem.Msg = '请等待'
								}
							})
							MyListdata1.push(resItem)
						})
						_this.Listdata = MyListdata1
						let params = {
							UpgradeFileId: _this.selectedFileId,
							List: _this.selectedListId,
						}
						_this.$axios.post(webapi.base_api_url + "/System/EquipmentUpgrade", params).then(res => {
							if (res.data.Code == 0) {
								//_this.handleSubmitList()
								//_this.handleSubmitFile()
								let MyListdata = []
								console.log(_this.Listdata);
								_this.Listdata.map(function(resItem) {
									console.log(resItem);
									res.data.Data.map(function(item) {
										console.log(resItem.EquipmentNo)
										console.log(item.EquipmentNo)
										if (resItem.ConnectorId == item.ConnectorId) {
											resItem.Code = item.Code
											resItem.Msg = item.Msg
										}
									})
									MyListdata.push(resItem)
								})
								console.log(MyListdata);
								_this.Listdata = MyListdata
							}
						})
						//_this.selectedFileId = '';
						_this.selectedListId = [];
						_this.$refs.currentRowTable.clearCurrentRow();
					}
				});
			},
			// delFile: function() {
			// 	const _this = this
			// 	if (_this.selectedFileId == '') {
			// 		_this.$Message.error("请点击文件列表选择要删除的文件")
			// 	} else {
			// 		let params = {
			// 			UpgradeFileId: _this.selectedFileId
			// 		}
			// 		_this.$axios.post(webapi.base_api_url + "/System/DeleteFileById", params).then(res => {
			// 			if (res.data.Code == 0) {
			// 				_this.handleSubmitList()
			// 				_this.handleSubmitFile()
			// 				this.$Message.info('文件删除成功');
			// 			}
			// 		})
			// 	}
			// 	_this.selectedFileId = '';
			// 	_this.$refs.currentRowTable.clearCurrentRow();
			// },
			// //删除修改之外的其他操作
			// otherMethodStation: function(name, Id) {
			// 	let typeNum = (this.methodList.filter(function(item, index, arr) {
			// 		return item.Status == name
			// 	})[0]).Id
			// 	this.$axios.post(webapi.base_api_url + "/System/SetSysWidgetStatus ", {
			// 		Id: Id,
			// 		Status: typeNum
			// 	}).then(res => {
			// 		if (res.data.Code == 0) {
			// 			this.$Message.info(name + '成功');
			// 			this.handleSubmit();
			// 		}
			// 	})
			// },
			/******************组件固定方法*************************/
			show: function(type, params) {
				switch (type) {
					case 'up':
						this.$refs.ItemModal.show(type, params)
						break;
					case 'add':
						this.$refs.ItemModal.show(type, params)
						break;
						// case 'distribute':
						// this.$refs.DistributeModal.show(type, params)
						// break;
				}
			},
			// getDeviceData: function(data) {
			// 	this.Filedata = data.Data.List
			// },
			getFileList: function(data) {
				this.Filedata = data.Data.List
			},
			getDeviceList: function(data) {
				this.Listdata = data.Data.List
			},
			handleSubmitList: function() {
				this.$refs.sonPageList.getList("deviceList");
				this.handleSubmitFile();
			},
			handleSubmitFile: function() {
				this.$refs.sonPageFile.getList("fileList");
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 145;
				if (window.innerWidth < 1217) {
					this.tableHeight -= 53;
				}
				// if (window.innerWidth < 1017) {
				// 	this.tableHeight -= 53;
				// }
				if (window.innerWidth < 701) {
					this.tableHeight -= 53;
				}
			},
		},
	}
</script>

<style>
	.ivu-table-row-highlight td {
		background-color: #00FFFF;
	}
	
	.content-div {
		/* min-width: 1400px; */
		/* overflow-x: hidden; */
		width: 100%;
	}
	
	@media (min-width: 1500px) {
		.content-div {
			/* overflow-x: hidden; */
		}
	}
	
	.ivu-table-cell {
		padding-left: 8px;
		padding-right: 8px;
	}
</style>